<template>
    <div class="row">
        <div class="col-xs-12">
            <div style="text-align:center;border-bottom:1px solid lightgray;padding-bottom:10px;margin-bottom:10px;">
                <span>{{this.messaggioOrdine}}</span>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12 col-md-offset-3 col-md-6" style="text-align:center;">
            
            <img src="/Portals/0/images/OrdineRicevuto.png" /><br /><br />
            <!-- <input type="button" value="Esci dal sito" @click="esciSito"
                style="background-color:#EEEEEE;border:none;color:black;padding:10px;margin-right:10px;" /> -->
            <input type="button" value="Continua lo shopping" @click="redirectToSearch"
                style="background-color:#004F87;color:white;border:none;padding:10px;" />
        </div>
    </div>

     <!-- :on-cancel="onCancel" -->
    <div class="vld-parent">
      <loading v-model:active="fullPageLoading_checkoutCompletato"
                :color="colorSpinner"
                :can-cancel="false"
                :is-full-page="true" />
    </div>
</template>

<script>

//import webApiProxy from "@/services/webApiProxy.js";
import Loading from 'vue-loading-overlay';  //per loading a schermo intero
import 'vue-loading-overlay/dist/vue-loading.css';  //per loading a schermo intero

export default {
    data(){
        return {
            colorSpinner:'#004F87',
            fullPageLoading_checkoutCompletato: false
        }
    },
    props: {
        n: {
            type: String,
            required: true,
            default: '0'
        },
        ord: {
            type: String,
            required: true,
        }
    },
    components:{
        Loading
    },
    computed: {
        messaggioOrdine(){
            switch(this.n){
                case '0':
                default:
                    return `La proposta d’ordine ${this.ord} è stata trasmessa correttamente. Ti abbiamo mandato una notifica via mail.`;
                case '1':
                    return "Ordine ricevuto correttamente ma a causa di un problema tecnico non è stato possibile inviare per email copia dell'ordine.";
            }
        }
    },
    methods: {
        redirectToSearch(){
            document.location = '/search';
        },
        // async esciSito(){
        //     this.fullPageLoading_checkoutCompletato = true;
        //     await webApiProxy.logoutUser()
        //         .then(() =>{
        //             console.log("Logout user completato. Redirect a home page...");
        //             document.location = '/';
        //         })
        //         .catch(error => {
        //             console.log(error);
        //         });
            
        //     this.fullPageLoading_checkoutCompletato = false;
        // }
    }
}
</script>

<style>

</style>